import { useTranslation } from 'react-i18next';
import { withStyles } from 'vopay';
import { BodyText, CopyButton } from 'UI';
import { IntegrationStepsHowItWorks } from '../types';
import IntegrationInstructionsDialog from './IntegrationInstructionsDialog';
import IntegrationSteps from './IntegrationSteps';
import styles from './IntegrationHowItWorksDialog.module.scss';

const cn = withStyles(styles);

type IntegrationHowItWorksDialogProps = {
  howItWorks: IntegrationStepsHowItWorks;
  isOpen: boolean;
  onClose: () => void;
};

/** The integration's workflow, opened from the setup drawer: intro, the example value to copy, then the steps */
export default function IntegrationHowItWorksDialog({ howItWorks, isOpen, onClose }: IntegrationHowItWorksDialogProps) {
  const { t } = useTranslation('translations', { keyPrefix: 'Integrations.IntegrationHowItWorksDialog' });
  // Catalogue copy resolves against a root t with full keys (see ../types.ts)
  const { t: tRoot } = useTranslation();
  const { intro, example, steps } = howItWorks;

  return (
    <IntegrationInstructionsDialog
      icon="help"
      title={t('title', { defaultValue: 'How it works' })}
      isOpen={isOpen}
      onClose={onClose}
    >
      <div className={cn('content')}>
        <div className={cn('intro')}>
          <BodyText weight="md">{intro(tRoot)}</BodyText>

          {example && (
            <div className={cn('example')}>
              <span className={cn('exampleText')}>{example}</span>
              <CopyButton content={example} size="20px" />
            </div>
          )}
        </div>

        <IntegrationSteps steps={steps} />
      </div>
    </IntegrationInstructionsDialog>
  );
}
